module.exports = __webpack_public_path__ + "static/favicon-2347deb74bd1839e2405113a175b8803.ico";